import type { ErrorHandler } from '@angular/core';
import { Injectable } from '@angular/core';
import { ServerErrorHandlerService } from './server-error-handler.service';

import type { HttpErrorResponse, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import type { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import type { HandleErrorError } from './error-handler';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService extends ServerErrorHandlerService implements ErrorHandler {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(error);
      }),
    );
  }

  /**
   * handleError catches any unhandled runtime error on the client side
   * Note: This stops execution of any code
   *
   * @param {object} error - Native error throwned by Angular
   */
  handleError(error: Partial<HandleErrorError> | string | undefined): void {
    try {
      // Handle string errors
      if (typeof error === 'string') {
        // eslint-disable-next-line no-console
        console.error(
          JSON.stringify({
            name: 'Error',
            message: error,
            url: 'N/A',
            status: 'N/A',
            apiMessage: 'N/A',
            apiCode: 'N/A',
          })
            .replace(/(\\r|\\n)+/g, ' ')
            .replace(/ +/g, ' '),
        );
        return;
      }

      // Handle object errors
      // Stringify the output to a single line JSON
      // eslint-disable-next-line no-console
      console.error(
        JSON.stringify({
          name: error?.name ?? 'Error',
          message: error?.message ?? 'N/A',
          url: error?.url ?? 'N/A',
          status: error?.status ?? 'N/A',
          apiMessage: error?.error?.errorList?.[0]?.message ?? 'N/A',
          apiCode: error?.error?.errorList?.[0]?.code ?? 'N/A',
        })
          .replace(/(\\r|\\n)+/g, ' ')
          .replace(/ +/g, ' '),
      );
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Unable to serialize handleError');
    }
  }

  /**
   * user initiated client side log
   *
   * @param {any} log - Data passed in by user
   */
  log = (msg) => {
    this.visionData.userInitiatedLog = JSON.stringify(msg);
    console.log(this.visionData);
  };

  /**
   * user initiated client side log
   *
   * @param {any} log - Data passed in by user
   */
  warning = (warn) => {
    this.visionData.userInitiatedLog = JSON.stringify(warn);
    console.warn(this.visionData);
  };

  /**
   * user initiated clint side log
   *
   * @param {any} log - Data passed in by user
   */
  error = (err) => {
    this.visionData.userInitiatedLog = JSON.stringify(err);
    console.error(this.visionData);
  };
}
